<template>
  <div ref="chart" class="iframe" v-show="position.show">
    <iframe
      class="frameset"
      frameborder="0"
      scrolling="auto"
      marginwidth="0"
      marginheight="0"
      vspace="0"
      hspace="0"
      allowtransparency="true"
      allowfullscreen="true"
      :style="{
        width: `calc(100% + 10px)`,
        height: `100%`
      }"
      :src="option.src"
      title=""
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      width: null,
      height: null,
      scale: 1
    }
  },
  computed: {
    // 屏幕高
    screenWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    },
    // 屏幕宽
    screenHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    }
  },
  props: {
    option: {
      type: Object,
      default() {
        return {}
      }
    },
    position: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.iframe {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.frameset {
  transform-origin: 0 0;
  background-color: transparent;
  // z-index: -1;
  position: relative;
}
</style>
